import { applyMiddleware, combineReducers, compose, createStore } from 'redux';
import thunk from 'redux-thunk';
import { connectRouter } from 'connected-react-router'
import logger from 'redux-logger';
// import rootSaga from './sagaes';
import { createBrowserHistory } from 'history'
import { routerMiddleware } from 'connected-react-router'
import createSagaMiddleware from 'redux-saga'
import * as Mail from './Components/Mail/Saga/Mail';
import * as Kyousai from './Components/Kyousai/Saga/Kyousai';
import * as ContractSearch from './Components/ContractSearch/Saga/ContractSearch';
import * as Master from './Store/Master';
import * as Water from './Components/Water/Saga/Water';
import * as Accounting from './Components/Accounting/Saga/Accounting';
import * as ContractCheck from './Components/ContractCheck/Saga/ContractCheck';
import * as RemittanceLogCheck from './Components/RemittanceLogCheck/Saga/RemittanceLogCheck';
import * as DirectDebitCheck from './Components/DirectDebitCheck/Saga/DirectDebitCheck';

import * as Minori from './Components/Minori/Saga/Minori';
import * as RentMoney from './Components/RentMoney/Saga/RentMoney';
import * as Transfer from './Components/Transfer/Saga/Transfer';

import * as OfficeContracts from './Components/OfficeContracts/Saga/OfficeContracts';
import * as ContractsList from './Components/ContractsList/Saga/ContractsList';
import * as ContractConfirm from './Components/ContractConfirm/Saga/ContractConfirm';

import { reducer as reduxFormReducer } from 'redux-form';

// import * as Detail from './Components/Detail/Saga/Detail';
// import * as Rent from './Components/Rent/Saga/Rent';
// import * as Coming from './Components/Coming/Saga/Coming';

// import * as Reserve from './Components/Reserve/Saga/Reserve';
import * as Monies from './Components/Accounting/Saga/Monies';
import * as RemittanceDetail from './Components/RemittanceDetail/Saga/RemittanceDetail';
import * as Kys from './Components/Kys/Saga/Kys';
import * as KyDetail from './Components/KyDetail/Saga/KyDetail';
import * as MonthlyMoney from './Components/MonthlyMoney/Saga/MonthlyMoney';
import * as ResponseData from './Components/ResponseData/Saga/ResponseData';
import * as CashTeller from './Components/CashTeller/Saga/CashTellers';


import * as OwnerMail from './Components/OwnerMail/Saga/OwnerMail';

import * as RentMoneyBulkInsert from './Components/RentMoneyBulkInsert/Saga/RentMoneyBulkInsert';

import { all } from 'redux-saga/effects';



export const history = createBrowserHistory()
const sagaMiddleware = createSagaMiddleware()

const reducers = {
    form: reduxFormReducer, // mounted under "form"
    masterReducer: Master.masterReducer,
    mailReducer: Mail.mailReducer,
    // Detail:Detail.detailReducer,
    rentContractMoniesReducer: Monies.rentContractMoniesReducer,

    kyousaiReducer: Kyousai.kyousaiReducer,

    contractsearchReducer: ContractSearch.contractsearchReducer,

    waterReducer: Water.waterReducer,


    Accounting: Accounting.accountingReducer,


    ContractCheck: ContractCheck.contractcheckReducer,

    RemittanceLogCheck: RemittanceLogCheck.remittancelogcheckReducer,
    DirectDebitCheck: DirectDebitCheck.direct_debit_check_Reducer,
    Minori: Minori.minoriReducer,

    RemittanceDetail: RemittanceDetail.remittance_detail_Reducer,
    RentMoney: RentMoney.rentmoneyReducer,


    Transfer: Transfer.transferReducer,
    kys: Kys.kysReducer,
    KyDetail: KyDetail.kydetailReducer,
    MonthlyMoney: MonthlyMoney.monthlyMoneyReducer,
    ResponseData: ResponseData.ResponseDataReducer,
    OwnerMail: OwnerMail.ownerMailReducer,
    RentMoneyBulkInsert: RentMoneyBulkInsert.rentMoneyBulkInsertReducer,
    CashTeller: CashTeller.CashTellerReducer,

    OfficeContracts: OfficeContracts.officecontractsReducer,
    ContractsList: ContractsList.contractslistReducer,
    ContractConfirm: ContractConfirm.contractconfirmReducer,
};
const rootReducer = combineReducers({
    router: connectRouter(history),
    ...reducers // rest of your reducers
});





export function* rootSaga() {
    yield all([

        ...Master.masterSaga,
        ...Mail.mailSaga,
        // ...Detail.detailSaga,
        // ...Rent.rentSaga,
        // ...Reserve.reserveSaga,
        // ...Coming.comingSaga,
        ...Monies.moniesSaga,
        ...Kyousai.kyousaiSaga,
        ...ContractSearch.contractsearchSaga,
        ...Water.waterSaga,
        ...Accounting.accountingSaga,
        ...ContractCheck.contractcheckSaga,
        ...RemittanceLogCheck.remittancelogcheckSaga,
        ...DirectDebitCheck.direct_debit_check_Saga,
        ...Minori.minoriSaga,
        ...RemittanceDetail.remittance_detail_Saga,
        ...RentMoney.rentmoneySaga,
        ...Transfer.transferSaga,
        ...KyDetail.kydetailSaga,
        ...Kys.kysSaga,
        ...MonthlyMoney.monthlyMoneySaga,
        ...ResponseData.ResponseDataSaga,
        ...OwnerMail.ownerMailSaga,
        ...RentMoneyBulkInsert.rentMoneyBulkInsertSaga,
        ...CashTeller.CashTellerSaga,
        ...OfficeContracts.OfficeContractsSaga,
        ...ContractsList.ContractsListSaga,
        ...ContractConfirm.ContractConfirmSaga,
    ]);
}




export default function configureStore(preloadedState) {
    const store = createStore(
        rootReducer, // root reducer with router state
        preloadedState,
        compose(
            applyMiddleware(
                routerMiddleware(history), // for dispatching history actions
                thunk,
                logger,
                sagaMiddleware,
                // ... other middlewares ...
            ),
        ),
    )
    sagaMiddleware.run(rootSaga)

    return store
}
